export default [{
  path: 'chargedocuments',
  name: 'chargedocuments-client',
  component: () => import('@/app/clientarea-app/charge-document/ChargeDocumentView')

}]
